import type { MetaDescriptor } from 'react-router';
import { parseURL } from '@archipro-website/top-navigation';
import { NON_FILTER_KEYS } from './no-index-product-category';
import { noIndexNoFollow } from '@modules/seo/util/no-index-no-follow';
import { hasSortParam } from './has-sort-param';

/**
 * Index page for no filter or professionals/service used filter on project category pages.
 * Non-indexable pages get `noindex` only (never `nofollow`) so link equity keeps flowing
 * through filter pages to projects.
 * @param metaDescriptors
 * @param url
 * @returns
 */
export const noIndexProjectCategory = (
    metaDescriptors: MetaDescriptor[],
    url: string,
): MetaDescriptor[] => {
    if (!url.startsWith('/projects')) return metaDescriptors;

    return noIndexNoFollow(
        true,
        false,
        isLocationIndexPage(url),
        metaDescriptors,
    );
};

export const isLocationIndexPage = (url: string): boolean => {
    const { params } = parseURL(url);
    const filterKeys = Object.keys(params).filter(
        (key) => !NON_FILTER_KEYS.includes(key),
    );

    const hasCompanyFilter = filterKeys.includes('company');
    const hasProfessionFilter = filterKeys.includes('profession');

    return (
        !hasSortParam(params) &&
        !filterKeys.length &&
        !hasCompanyFilter &&
        !hasProfessionFilter
    );
};
